/* Hematix only. Shopify is authoritative for BOGO, line prices and checkout. */
(() => {
  'use strict';
  if (customElements.get('hematix-commerce')) return;
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const trash = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 6h16M9 6V3h6v3M7 6l1 15h8l1-15M10 10v7M14 10v7"/></svg>';
  customElements.define('hematix-commerce', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.variant = Number(this.dataset.variant);
      this.protectionVariant = Number(this.dataset.protectionVariant);
      this.root = this.dataset.root || '/';
      this.form = document.getElementById(this.dataset.form);
      this.product = JSON.parse(this.querySelector('[data-product-json]').textContent);
      const template = this.querySelector('[data-hematix-cart-template]');
      if (!this.variant || !this.form || !template) return;
      document.body.append(template.content.cloneNode(true));
      this.overlay = document.querySelector('.hematix-cart-overlay');
      this.panel = this.overlay.querySelector('.hematix-cart-panel');
      this.moneyFormat = new Intl.NumberFormat('en-US', {style:'currency',currency:this.dataset.currency || 'USD'});
      this.addEventListener('change', event => {
        if (event.target.matches('input[name="hematix-offer"]')) this.syncOffer();
      });
      this.onSubmit = event => {
        if (event.target !== this.form) return;
        event.preventDefault(); event.stopImmediatePropagation();
        this.addBracelet();
      };
      this.addEventListener('submit', this.onSubmit, true);
      this.onCartLink = event => {
        const link=event.target.closest('#cart-icon-bubble, .lox-header a, .hematix-header-cart');
        if (!link || new URL(link.href,location.origin).pathname!==this.root+'cart') return;
        event.preventDefault(); event.stopImmediatePropagation(); this.open();
      };
      document.addEventListener('click', this.onCartLink, true);
      this.overlay.addEventListener('click', event => {
        const control = event.target.closest('[data-action]');
        if (!control) return;
        event.preventDefault();
        if (control.dataset.action === 'close') this.close();
        else if (control.dataset.action === 'protection') this.toggleProtection();
        else if (control.dataset.action === 'quantity') this.changeLine(control.dataset.key, Number(control.dataset.quantity));
      });
      this.overlay.addEventListener('change', event => {
        if (event.target.matches('[data-line-quantity]')) this.changeLine(event.target.dataset.key, Number(event.target.value));
      });
      this.overlay.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); this.close(); }
        if (event.key !== 'Tab') return;
        const focusable = [...this.panel.querySelectorAll('button:not(:disabled),a[href],input:not(:disabled)')].filter(e => e.getClientRects().length);
        if (!focusable.length) return;
        const first=focusable[0], last=focusable[focusable.length-1];
        if (event.shiftKey && (document.activeElement===first || document.activeElement===this.panel)) {event.preventDefault();last.focus();}
        else if (!event.shiftKey && document.activeElement===last) {event.preventDefault();first.focus();}
      });
      this.syncOffer();
    }
    disconnectedCallback() {
      document.removeEventListener('click',this.onCartLink,true);
      if (this.overlay && !this.overlay.hidden) this.close();
      this.overlay?.remove();
    }
    money(cents) {return this.moneyFormat.format(Number(cents || 0)/100);}
    syncOffer() {
      const selected=this.querySelector('input[name="hematix-offer"]:checked');
      this.quantity=selected?.value==='1' ? 1 : 2;
      this.querySelector('input[name="quantity"]').value=String(this.quantity);
      this.form.querySelector('[name="id"]').value=String(this.variant);
      this.querySelectorAll('.hematix-offer').forEach(label => {
        const q=Number(label.closest('label').querySelector('input').value);
        label.querySelector('[data-offer-price]').textContent=this.money(this.dataset.price);
        const compare=label.querySelector('[data-offer-compare]');
        compare.textContent=this.money(Number(this.dataset.compare)*q);
        compare.hidden=Number(this.dataset.compare)<=Number(this.dataset.price);
      });
      this.querySelector('[data-hematix-price]').textContent=this.money(this.dataset.price);
      document.querySelectorAll('[data-hematix-sticky-price]').forEach(e=>e.textContent=this.money(this.dataset.price));
      this.form.querySelectorAll('[class^="main-atc-price-span-"]').forEach(e=>e.textContent=this.money(this.dataset.price));
    }
    async request(path, body) {
      const response=await fetch(this.root+path,{method:body ? 'POST':'GET',headers:{'Accept':'application/json',...(body?{'Content-Type':'application/json'}:{})},credentials:'same-origin',...(body?{body:JSON.stringify(body)}:{})});
      const data=await response.json();
      if(!response.ok) throw new Error(data.description || data.message || 'Could not update the cart. Please try again.');
      return data;
    }
    showError(error) {
      const text=error?.message || 'Could not update the cart. Please try again.';
      const cartError=this.overlay.querySelector('[data-cart-error]');
      cartError.textContent=text;cartError.hidden=false;
      if(this.overlay.hidden) {
        const wrapper=this.querySelector('.product-form__error-message-wrapper');
        if(wrapper){wrapper.hidden=false;wrapper.querySelector('.product-form__error-message').textContent=text;}
      }
    }
    async addBracelet() {
      if(this.busy) return;
      const button=this.form.querySelector('[name="add"]');
      if(button.disabled) return;
      this.busy=true;button.disabled=true;
      const error=this.querySelector('.product-form__error-message-wrapper');if(error)error.hidden=true;
      try {
        await this.request('cart/add.js',{items:[{id:this.variant,quantity:this.quantity}]});
        await this.open();
      } catch(e) {this.showError(e);} finally {this.busy=false;button.disabled=false;}
    }
    async open() {
      try {
        this.cart=await this.request('cart.js');this.render();
        this.previousFocus=document.activeElement;
        this.previousOverflow=document.body.style.overflow;
        this.overlay.hidden=false;document.body.style.overflow='hidden';this.panel.focus();
      } catch(e) {this.showError(e);}
    }
    close() {
      this.overlay.hidden=true;document.body.style.overflow=this.previousOverflow || '';
      if(this.previousFocus?.isConnected)this.previousFocus.focus();
    }
    async changeLine(key, quantity) {
      if(this.busy || !Number.isInteger(quantity) || quantity<0 || quantity>100) return;
      this.busy=true;this.setBusy(true);
      try {
        if(key==='hematix-group') {
          const lines=this.cart.items.filter(i=>i.product_id===Number(this.dataset.product));
          const updates=Object.fromEntries(lines.map((i,index)=>[i.key,index===0?quantity:0]));
          this.cart=await this.request('cart/update.js',{updates});
        } else this.cart=await this.request('cart/change.js',{id:key,quantity});
        const service=this.cart.items.find(i=>i.variant_id===this.protectionVariant);
        if(service && !this.cart.items.some(i=>!['shipping-protection','hemios-shipping-protection','hematix-shipping-protection'].includes(i.handle))) this.cart=await this.request('cart/change.js',{id:service.key,quantity:0});
        this.cart=await this.request('cart.js');
        this.render();
      }
      catch(e){this.showError(e);}finally{this.busy=false;this.setBusy(false);}
    }
    async toggleProtection() {
      if(this.busy || !this.protectionVariant) return;
      this.busy=true;this.setBusy(true);
      try {
        this.cart=await this.request('cart.js');
        const item=this.cart.items.find(i=>i.variant_id===this.protectionVariant);
        if(!item && this.cart.items.some(i=>['shipping-protection','hemios-shipping-protection','hematix-shipping-protection'].includes(i.handle))) {this.render();return;}
        try {sessionStorage.setItem('loxhaven-shipping-protection-choice','false');} catch(e) {}
        if(item) await this.request('cart/change.js',{id:item.key,quantity:0});
        else await this.request('cart/add.js',{items:[{id:this.protectionVariant,quantity:1}]});
        this.cart=await this.request('cart.js');this.render();
      }catch(e){this.showError(e);}finally{this.busy=false;this.setBusy(false);}
    }
    setBusy(value) {
      this.panel.querySelectorAll('button:not([data-action="close"]),input').forEach(e=>e.disabled=value);
      this.panel.querySelector('[data-cart-checkout]').setAttribute('aria-disabled',String(value || !this.cart?.item_count));
    }
    render() {
      const cart=this.cart;
      this.panel.querySelector('[data-cart-error]').hidden=true;
      const service=i=>i.variant_id===this.protectionVariant || i.handle==='shipping-protection' || i.handle==='hematix-shipping-protection' || i.handle==='hemios-shipping-protection';
      const rawItems=cart.items.filter(i=>i.variant_id!==this.protectionVariant);
      const ownLines=rawItems.filter(i=>i.product_id===Number(this.dataset.product));
      const items=ownLines.length ? [{...ownLines[0],key:'hematix-group',quantity:ownLines.reduce((n,i)=>n+i.quantity,0),final_line_price:ownLines.reduce((n,i)=>n+i.final_line_price,0),original_line_price:ownLines.reduce((n,i)=>n+i.original_line_price,0),line_level_discount_allocations:ownLines.flatMap(i=>i.line_level_discount_allocations||[])},...rawItems.filter(i=>i.product_id!==Number(this.dataset.product))] : rawItems;
      const count=items.filter(i=>!service(i)).reduce((n,i)=>n+i.quantity,0);
      this.panel.querySelector('[data-cart-count]').textContent=count;
      const ownQuantity=items.filter(i=>i.product_id===Number(this.dataset.product)).reduce((n,i)=>n+i.quantity,0);
      // Existing Loxhaven delivery profile: free shipping at USD 79 after discounts.
      // cart.total_price includes optional services, matching the checkout order subtotal.
      const threshold=Number(this.dataset.freeShippingThreshold);
      const available=(cart.currency || this.dataset.currency)==='USD' && threshold>0;
      const subtotal=Math.max(0,Number(cart.total_price)||0);
      const free=available && count>0 && subtotal>=threshold;
      const label=!available?'Shipping calculated at checkout':free?'Free Shipping Unlocked!':'Add '+this.money(Math.max(0,threshold-subtotal))+' more for free shipping';
      this.panel.querySelector('[data-shipping-label]').textContent=label;
      const progress=this.panel.querySelector('[data-shipping-progress]');
      const percent=available && count>0?Math.min(100,subtotal/threshold*100):0;
      progress.style.width=percent+'%';
      progress.parentElement.hidden=!available;
      progress.parentElement.setAttribute('aria-valuenow',String(Math.round(percent)));
      progress.parentElement.setAttribute('aria-valuetext',label);
      this.panel.querySelector('[data-cart-items]').innerHTML=items.map(item=>{
        const own=item.product_id===Number(this.dataset.product);
        const compare=own ? Number(this.dataset.compare || item.original_price)*item.quantity : item.original_line_price;
        const price=item.final_line_price;
        const discounts=item.line_level_discount_allocations || [];
        const badge=discounts.some(d=>d.discount_application?.title?.startsWith('BUY 1 GET 1 FREE'));
        const image=item.featured_image?.url || item.image || (service(item) ? this.panel.querySelector('.hematix-cart-protection img').src : '');
        const picture=image ? '<img src="'+escape(image)+'" alt="'+escape(item.product_title)+'">' : '<svg class="hematix-cart-placeholder" viewBox="0 0 88 88" aria-hidden="true"><rect width="88" height="88" rx="6" fill="#f4f5f7"/><path d="M24 29h40v32H24zM31 29v-7h26v7" fill="none" stroke="#8793a0" stroke-width="2"/></svg>';
        return '<article class="hematix-cart-item">'+picture+'<div><div class="hematix-cart-item-top"><h3>'+escape(item.product_title)+'</h3><button class="hematix-cart-remove" data-action="quantity" data-key="'+escape(item.key)+'" data-quantity="0" aria-label="Remove '+escape(item.product_title)+'">'+trash+'</button></div><div class="hematix-cart-item-prices">'+(compare>price?'<del>'+this.money(compare)+'</del>':'')+'<span>'+this.money(price)+'</span>'+(compare>price?'<span class="hematix-cart-saving">(Save '+this.money(compare-price)+')</span>':'')+'</div><div class="hematix-cart-item-controls"><div class="hematix-cart-quantity"><button data-action="quantity" data-key="'+escape(item.key)+'" data-quantity="'+(item.quantity-1)+'" aria-label="Decrease quantity">−</button><input data-line-quantity data-key="'+escape(item.key)+'" type="number" min="0" max="100" value="'+item.quantity+'" aria-label="Product quantity"><button data-action="quantity" data-key="'+escape(item.key)+'" data-quantity="'+(item.quantity+1)+'" aria-label="Increase quantity">+</button></div>'+(badge?'<span class="hematix-cart-tag">◆ BUY 1 GET 1 FREE</span>':'')+'</div></div></article>';
      }).join('') || '<p class="hematix-cart-empty">Your cart is empty</p>';
      const protection=cart.items.find(i=>i.variant_id===this.protectionVariant);
      const otherProtection=cart.items.some(i=>i.variant_id!==this.protectionVariant && ['shipping-protection','hemios-shipping-protection','hematix-shipping-protection'].includes(i.handle));
      this.panel.querySelector('.hematix-cart-protection').hidden=!items.length || !this.protectionVariant || otherProtection;
      this.panel.querySelector('[data-action="protection"]').setAttribute('aria-checked',String(Boolean(protection)));
      this.panel.querySelector('[data-protection-price]').textContent=this.money(protection?.final_line_price ?? 390);
      this.panel.querySelector('[data-cart-discounts]').hidden=!cart.total_discount;
      this.panel.querySelector('[data-discount-amount]').textContent='− '+this.money(cart.total_discount);
      this.panel.querySelector('[data-cart-total]').textContent=this.money(cart.total_price);
      this.panel.querySelector('[data-cart-checkout]').setAttribute('aria-disabled',String(!items.length));
      this.panel.querySelector('.hematix-cart-promo').hidden=!ownQuantity;
      document.querySelectorAll('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]').forEach(e=>e.textContent=count);
      document.querySelectorAll('.lox-header a').forEach(e=>{if(new URL(e.href,location.origin).pathname===this.root+'cart')e.textContent='Cart'+(cart.item_count?' ('+cart.item_count+')':'');});
      document.querySelectorAll('.hematix-header-cart').forEach(e=>{let badge=e.querySelector('[data-hematix-header-count]');if(!badge){badge=document.createElement('span');badge.dataset.hematixHeaderCount='';e.append(badge);}badge.textContent=cart.item_count;badge.hidden=!cart.item_count;});
    }
  });
})();
